module.exports = __webpack_public_path__ + "static/media/3-warehouse-pic.cbd9375d.png";